import { action, observable, reaction, makeObservable } from 'mobx';
import {
  ContentLookup,
  contentLookupService,
  VersionedContentLookup,
  X1Language,
  X2AgeCategory
} from '../../../domain';
import {arrayToMap, Disposers, PromiseState} from '../../../lib/helpers';

export class X1LanguageLoader {
  @observable.ref
  state: PromiseState<VersionedContentLookup> | null;
  @observable.ref
  lookup: ContentLookup | null;
  @observable.ref
  language: X1Language | null;
  @observable.ref
  ageCategories: readonly X2AgeCategory[];
  @observable.ref
  ageCategoryById: { [index: number]: X2AgeCategory };

  private readonly disposers = new Disposers();

  constructor(readonly languageId: number) {
    makeObservable(this);
    this.state = null;
    this.lookup = null;
    this.language = null;
    this.ageCategories = [];
    this.ageCategoryById = {};
    this.setup();
  }

  private setup() {
    this.disposers.add(reaction(
      () => this.state?.state,
      this.onStateChange));
  }

  @action
  load = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.load();
  };

  @action
  refresh = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.refresh();
  };

  @action
  private onStateChange = () => {
    this.lookup = null;
    this.language = null;
    this.ageCategories = [];
    this.ageCategoryById = {};

    if (this.state?.isResolved !== true)
      return;
    let lookup = this.state.value.lookup;
    let language = lookup.X1LanguageById[this.languageId];
    if (language === undefined)
      return;
    this.lookup = lookup;
    this.language = language;
    this.ageCategories = language.AgeCategories!;
    this.ageCategoryById = arrayToMap(this.ageCategories, x => x.Id);
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
